import {useRouteQuery} from '@vueuse/router';
import {storeToRefs} from 'pinia';
import type {PageTypeHypermarketStoryblok} from '~/storyblok/types';
import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';

export default defineNuxtRouteMiddleware(() => {
	const hypermarketsStore = useStoryblokHypermarketsStore();
	const {selectedHypermarket} = storeToRefs(hypermarketsStore);
	const hm = useRouteQuery('hm') as PageTypeHypermarketStoryblok['slug'];

	if (hm.value && hm.value !== (selectedHypermarket.value ?? '')) {
		hypermarketsStore.setHypermarket(hm.value);
	}
});
